import { Navigate, useLocation, useParams } from 'react-router';

const MARKET_MAP: Record<string, string> = {
  usdc: '0xc3d688b66703497daa19211eedff47f25384cdc3',
  eth: '0xa17581a9e3356d9a858b789d68b4d866e593ae94'
};

const COLLATERAL_TOKENS: Record<string, Record<string, string>> = {
  usdc: {
    WBTC: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    WETH: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    COMP: '0xc00e94cb662c3520282e6f5717214004a7f26888',
    wstETH: '0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0',
    LINK: '0x514910771af9ca656af840dff83e8264ecf986ca',
    UNI: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
    cbBTC: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
    tBTC: '0x18084fba666a33d37592fa2633fd49a74dd93a88'
  },
  eth: {
    ezETH: '0xbf5495efe5db9ce00f80364c8b423567e58d2110',
    wstETH: '0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0',
    rETH: '0xae78736cd615f374d3085123a210448e74fc6393',
    weETH: '0xcd5fe23c85820f7b72d0926fc9b05b43e359b7ee',
    WBTC: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    rsETH: '0xa1290d69c65a6fe4df752f95823fae25cb99e5a7',
    osETH: '0xf1c9acdc66974dfb6decb12aa385b9cd01190e38',
    cbETH: '0xbe9895146f7af43049ca1c1ae358b0541ea49704',
    rswETH: '0xfae103dc9cf190ed75350761e95403b7b8afa6c0',
    cbBTC: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
    tBTC: '0x18084fba666a33d37592fa2633fd49a74dd93a88'
  }
};

export function OldRedirect() {
  const { market, collateral, wallet, collateralBuyer } = useParams();
  const location = useLocation();

  if (!market) {
    return null;
  }

  const path = location.pathname.replace(/\/$/, '');

  const pathSegments = path.split('/');

  const marketAddress = MARKET_MAP[market];
  let to = `/ethereum/${marketAddress}`;

  if (collateral) {
    const collateralAddress = COLLATERAL_TOKENS[market][collateral];
    to += `/${collateralAddress}`;
  }

  if (pathSegments.at(-1) === 'wallets') {
    to += '/borrowers';
  }

  if (wallet) {
    to += `/borrowers/${wallet}`;
  }

  if (pathSegments.at(-1) === 'liquidations') {
    to += '/liquidations';
  }

  if (collateralBuyer) {
    to += `/liquidations/collateral-buyers/${collateralBuyer}`;
  }

  if (pathSegments.at(-1) === 'activity') {
    to += '/activity';
  }

  return <Navigate to={to} />;
}
